import common from '@/validator/CommonRules'

/**
 * ユーザー登録 バリデーションルール
 */
export default {
  userId: 'required|' + common.userId,
  password: {
    create: 'required|confirmed:password-confirmation|' + common.passwordRule,
    edit: 'confirmed:password-confirmation|' + common.passwordRule,
  },
  passwordConfirmation: {
    create: 'required|confirmed:password|' + common.passwordRule,
    edit: 'confirmed:password|' + common.passwordRule,
  },
  name: 'required|max:128',
  authority: 'required',
}
